// extracted by mini-css-extract-plugin
export var boldText = "_88-4";
export var checkboxContainer = "_88-6";
export var closeIcon = "_88-i";
export var container = "_88-0";
export var drawer = "_88-8";
export var drawerContent = "_88-9";
export var extraSmallText = "_88-5";
export var fulfillmentGroupTable = "_88-e";
export var largeText = "_88-3";
export var loadingSpinnerContainer = "_88-j";
export var mediumText = "_88-2";
export var narrow = "_88-f";
export var notificationLink = "_88-l";
export var packageCheckIconContainer = "_88-7";
export var slideoutHeaderActions = "_88-g";
export var slideoutHeaderActionsShifted = "_88-h";
export var slideoutHeaderContainer = "_88-a";
export var slideoutModal = "_88-c";
export var stickyHeaderWrapper = "_88-b";
export var table = "_88-k";
export var tableContainer = "_88-d";
export var tertiaryText = "_88-1";